import React, { useEffect, useState } from 'react'
import { Grid, Paper, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import {
  GeneralPostingOptions,
  PostingTemplate, PreviewFormat,
  SocialMediaNetwork,
} from '@professocial/professocialTypes/types/commonTypes'

import CreatePosting from './CreatePosting'
import CreatePostingOptions from './CreatePostingOptions'
import CreatePostingAddOns from './CreatePostingAddOns'

import { PostingScreen, Restrictions, PostPlaning } from '../../types/types'
import { PostingActionType } from '../../../screens/ProfessocialPosting'
import { useSelector } from 'react-redux'
import { getGeneralPostingOptions } from '../../../store/common/common.selectors'

const useStyles = makeStyles((theme: Theme) => ({
  paperButtons: {
    marginTop: '10px',
    padding: '19px 22px',
  },
  paper: {
    marginTop: '10px',
    padding: '25px 30px',
  },
}))

interface IPostingProps {
  allowedSocialMediaNetworks?: SocialMediaNetwork
  posting: PostingTemplate
  previewFormat?: PreviewFormat
  restrictions?: Restrictions
  date: PostPlaning
  sendAction?: (action: PostingActionType) => void
  changePosting?: (post: PostingTemplate) => void
  changePostingScreen: (screen: PostingScreen) => void
  changePublishDate?: (span: PostPlaning) => void
}

const Posting: React.FC<IPostingProps> = (props) => {
  const classes = useStyles()

  const generalPostingOptions: GeneralPostingOptions = useSelector(getGeneralPostingOptions)
  const [socialMediaNetworks, setSocialMediaNetworks] = useState<SocialMediaNetwork>(props.allowedSocialMediaNetworks || {})

  useEffect(() => {
    setSocialMediaNetworks(props.allowedSocialMediaNetworks || {})
  }, [props.allowedSocialMediaNetworks],
  )

  const [posting, setPosting] = useState<PostingTemplate>(props.posting)

  useEffect(() => {
    props.posting && setPosting(props.posting)
  }, [props.posting],
  )

  return (
    <>
      <Grid container>
        {generalPostingOptions.showAsPopUp && (
          <Grid xs={12} item>
            <Paper className={classes.paperButtons} variant={undefined}>
              <CreatePostingAddOns
                posting={posting}
                changePosting={(post: PostingTemplate) => { props.changePosting && props.changePosting(post) }}
                changePostingScreen={(screen: PostingScreen) => { props.changePostingScreen && props.changePostingScreen(screen) }}
              />
            </Paper>
          </Grid>)}
        <Grid xs={12} item>
          <Paper className={classes.paper} variant={generalPostingOptions.showAsPopUp ? undefined : 'elevation'}>
            <CreatePosting
              previewFormat={props.previewFormat || PreviewFormat.square}
              posting={posting}
              allowedSocialMediaNetworks={socialMediaNetworks}
              changePosting={(post: PostingTemplate) => { props.changePosting && props.changePosting(post) }}
            />
          </Paper>
        </Grid>
        {!generalPostingOptions.showAsPopUp && (
          <Grid xs={12} item>
            <Paper className={classes.paperButtons}>
              <CreatePostingAddOns
                posting={posting}
                changePosting={(post: PostingTemplate) => { props.changePosting && props.changePosting(post) }}
                changePostingScreen={(screen: PostingScreen) => { props.changePostingScreen && props.changePostingScreen(screen) }}
              />
            </Paper>
          </Grid>)}
        <Grid xs={12} item>
          <CreatePostingOptions
            restrictions={props.restrictions}
            allowedSocialMediaNetworks={socialMediaNetworks}
            posting={posting}
            date={props.date && props.date}
            changePosting={(post: PostingTemplate) => { props.changePosting && props.changePosting(post) }}
            changePublishDate={props.changePublishDate && props.changePublishDate}
            sendAction={props.sendAction && props.sendAction}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default Posting
